import DeleteTrigger from "./DeleteTrigger";

export default DeleteTrigger